import * as Yup from 'yup';
import {
  nonEmptyReqValidator,
  nonWhiteSpaceValidator,
} from '@gokrew/ui/utility/validators';
import type { TranslationNS } from '@gokrew/models/constants';
import type { TFunction } from 'i18next';

/**
 * The departmentSchema is used to validate the data provided in the department creation/updation form.
 * It requires the name and description fields to be present and non-empty.
 */
export const departmentSchema = (t: TFunction<TranslationNS.Department>) =>
  Yup.object({
    name: nonEmptyReqValidator(t('validation.name')).required(
      t('validation.name')
    ),
    description: nonWhiteSpaceValidator(t('validation.description')),
  });
